import { fetchConditionalPropertyRules } from '../../form/api';
export class ConditionalPropertyRulesCache {
  constructor() {
    this.cache = {};
  }

  get({
    objectTypeId,
    httpClient,
    includeActualConditionalPropertyRules = true
  }) {
    if (Object.prototype.hasOwnProperty.call(this.cache, objectTypeId)) {
      return this.cache[objectTypeId];
    }

    const promise = fetchConditionalPropertyRules(objectTypeId, httpClient, {
      includeActualConditionalPropertyRules
    }).then(conditionalPropertyRules => {
      return conditionalPropertyRules;
    }).catch(__err => {
      return [];
    });
    this.cache[objectTypeId] = promise;
    return promise;
  }

  clear() {
    this.cache = {};
  }

}